import { getElementID, getElements } from "./DOM"
import * as Cookies from 'js-cookie';
import { scroll } from "../app";

export const loginPage = () => {
  const formElement = getElementID('formLogin') as HTMLFormElement;

  if (!formElement) {
    return;
  }

  const errorMessageElement = getElementID('errorMessage');
  const inputs = getElements('.input-element__input', formElement) as NodeListOf<HTMLInputElement>;

  const showError = () => {
    errorMessageElement.classList.add('isActive');
    scroll.scrollingElement.scrollTop = 0;
  }

  formElement.addEventListener('submit', (e: Event) => {
    e.preventDefault();

    errorMessageElement.classList.remove('isActive');

    for (let i in inputs) {
      const input = inputs[i]

      if (input.value === undefined) {
        continue;
      }

      if (!input.value.length) {
        showError();
        return;
      }
    }

    if (inputs[1].value[1] !== 'e') {
      showError();
      return
    }

    const { search, origin } = window.location;

    Cookies.set('login', true);

    window.location.replace(`${origin}/${search.substring(1)}`);
  });
}